enum UhType {
  Order = "Order",
  ThirdPartyOrder = "ThirdPartyOrder",
  UsabilityTest = "UsabilityTest",
  TestSet = "TestSet",
}

export default UhType
